import { CAST_AI } from '@cast/constants';
import {
  Alert,
  Box,
  Stack,
  Typography,
  colorOrToken,
  tokens,
} from '@cast/design-system';

import { SelectAutoscalerTypeRadio } from './SelectAutoscalerTypeRadio';
import { AutoscalerType } from '../../../types';

type Props = {
  autoscalerType: AutoscalerType;
  onChange: (autoscalerType: AutoscalerType) => void;
};

export const SelectAutoscalerType = ({ autoscalerType, onChange }: Props) => {
  return (
    <Stack gap={12} data-testid="select-autoscaler-type">
      <Typography variant="L10R" color={tokens.theme.fg.structural.secondary}>
        Node provisioning
      </Typography>
      <Box display="grid" gridTemplateColumns="repeat(2, 1fr)" gap={8}>
        <SelectAutoscalerTypeRadio
          testId="other-autoscaler-radio"
          autoscalerType="cast-ai"
          checked={autoscalerType === 'cast-ai'}
          onClick={() => onChange('cast-ai')}
        />
        <SelectAutoscalerTypeRadio
          testId="karpenter-autoscaler-radio"
          autoscalerType="karpenter"
          checked={autoscalerType === 'karpenter'}
          onClick={() => onChange('karpenter')}
        />
      </Box>
      {autoscalerType === 'karpenter' && (
        <Alert color="warning" noIcon size="sm">
          <Typography
            variant="inherit"
            color={colorOrToken('grey.900', tokens.theme.fg.structural.primary)}
          >
            Karpenter must already be running in this cluster. {CAST_AI} will
            extend it without replacing it as your node provisioner.
          </Typography>
        </Alert>
      )}
    </Stack>
  );
};
